// extracted by mini-css-extract-plugin
module.exports = {"lead":"_583486"};